import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { NumberPicker } from '../../components';
import { PaxConstants } from '../../models';

export const PaxSelectorContentRow = ({ cmsKey, min, max, paxKey, onChange, value, ageCmsKey }) => {
    const { t } = useTranslation();
    const classRow = classNames('odf-flex-container-row odf-flex-container-nogutter odf-space-outer-bottom-m odf-text-md');
    return (
        <div className={classRow} data-testid="pax-selector-item">
            <div className="odf-flex-item odf-text-ellipsis">
                <span
                    dangerouslySetInnerHTML={{
                        __html: t(`paxSelector.${cmsKey}.text`),
                    }}
                />
                {paxKey !== PaxConstants.ROOMS && (
                    <span
                        className="odf-space-inner-left-xs"
                        dangerouslySetInnerHTML={{
                            __html: t(`${ageCmsKey}.${cmsKey}.age`),
                        }}
                    />
                )}
            </div>
            <div className="odf-flex-item odf-flex-item-sm">
                <NumberPicker
                    min={min}
                    max={max}
                    value={value}
                    onChange={(val) => onChange({ [paxKey]: val })}
                />
            </div>
        </div>
    );
};

PaxSelectorContentRow.propTypes = {
    min: PropTypes.number,
    max: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
    cmsKey: PropTypes.string.isRequired,
    paxKey: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    ageCmsKey: PropTypes.string,
};

PaxSelectorContentRow.defaultProps = {
    min: 0,
    ageCmsKey: 'paxSelector',
};
